import axiosCall from './interceptor';
import URL from '../helper';

export const saveThumbnail = async (imageData, id, isTemplate = true) => {
  const url = `${URL.BASE_URL}thumbnail?mailTemplateId=${id}&isTemplate=${isTemplate}`;
  let form = new FormData();
  form.append('fileType', 'image');
  form.append('imageFile', imageData);
  let response = await axiosCall('post', url, form);
  let result = response.data;
  if (result) {
    result.thumbnail = response.data.imageLink;
  }
  return result;

}
